import ActionTypes from "./ActionTypes";

const getUser = (payload) => {
  return {
    type: ActionTypes.GET_USER,
    payload: payload,
  };
};

const isLogin = (payload) => {
  return {
    type: ActionTypes.IsLogin,
    payload: payload,
  };
};

const EmailNotification = (payload) => {
  return {
    type: ActionTypes.EmailNotification,
    payload: payload,
  };
};

const get_staff = (payload) => {
  return {
    type: ActionTypes.GET_STAFF,
    payload,
  };
};
const reset_staff = () => {
  return {
    type: ActionTypes.RESET_STAFF,
  };
};

const isLogout = (payload) => {
  return {
    type: ActionTypes.IsLogout,
    payload: payload,
  };
};

const getDealerDashboard = (payload) => {
  return {
    type: ActionTypes.GET_DEALER_DASHBOARD,
    payload: payload,
  };
};

const get_logs = (payload) => {
  return {
    type: ActionTypes.LOGS,
    payload,
  };
};

const IsReset = (payload) => {
  return {
    type: ActionTypes.IsReset,
    payload,
  };
}


export { getUser, isLogin, EmailNotification, isLogout, get_staff, reset_staff, getDealerDashboard,get_logs, IsReset};
